export interface HistoryFilters {
  textQuery?: string;
  shift?: number;
}

export const defaultDropdownValue = 0;
